import React, {Component} from 'react';
import axios from "axios";
import config from 'react-global-configuration';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from 'react-router-dom';
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class MerchantViewer extends Component {
    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            //loading: false,
            file_name: null,
            brand_files : [],
            brandData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: '',
               
            },
            brandModel: false,
            data:[],
            raw_display_data: [],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[],
            changedItems:[],
            emiMenus:[],
            file_name_display: null
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.getFileName();
        console.log(this.props.match.params);
        this._refreshBrand_View();
        this.setState({ 
            _notificationSystem: this.refs.notificationSystem,
            file_name: this.props.match.params.id       
        });
        var _notificationSystem = this.refs.notificationSystem;
    }

    getFileName(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);
        axios.get(config.get('API_URL') + '/brandemi/get_file_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            let file_name_to_display = response.data;
            this.setState({
                file_name_display: file_name_to_display[0].file_name
            })
        });
    }

    brandData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            brandData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            brandModel: !this.state.brandModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }

    togglebrandModel() {
        this.setState({
            brandModel: !this.state.brandModel
        })
    }
    
    _refreshBrand_View() {
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);
        axios.get(config.get('API_URL') + '/brandemi/view_merchant_product_master_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                raw_display_data: response.data
            });
            $('#brandViewTable').DataTable();
            this.setState({
                loading: false
            });
            //this.preAppender();

        });
    }


    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }

    mappingHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.changedItems));
        data.append('userGroup', decoded.userGroup);
        console.log(data);
        axios.post(config.get('API_URL') + "/brandemi/map_data", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, res.data.success);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        };

    render() {

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });
        console.log(this.state.changedItems);    
        //console.log(this.state.relationData);
        let versions = this.state.versions.map((version,index) => {
            return (
                <option value={version.id} key={index+1}>{version.name}</option>
            )
        });

        let tablesData = this.state.tableLists.map((table,index) => {
            return (
                <option value={table.id} key={index+1}>{table.tableName}</option>
            )
        });


        let brand_data = this.state.raw_display_data.map((value,index) => {
            return (
                <tr key={index + 1}>
                <td>{index+1}</td>
                <td>{value.brand}</td>
                <td>{value.category}</td>
                <td>{value.level_1}</td>
                <td>{value.level_2}</td>
                <td>{value.level_3}</td>
                <td>{value.level_4}</td>
                <td>{value.sku}</td>
                <td>{value.product_code}</td>
                <td>{value.mrp}</td>
                <td>{value.mop}</td>
                <td>{value.brand_sku}</td>
                <td>{(value.mapping_flag)? 'Yes' : 'No'}</td>
            </tr>
            )
        });

        return(
            <div className="content">
                <CommonNavbar/>
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="col-md-12">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">{this.state.file_name_display}</h4>
                            </div>
                            <div className="content notoppadding">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-full-width table-responsive">
                                            <table className="table table-striped table-hover" id="brandViewTable">
                                                <thead>
                                                    <tr>
                                                        <th>Sr No.</th>
                                                        <th>Brand</th>
                                                        <th>Category</th>
                                                        <th>Level 1</th>
                                                        <th>Level 2</th>
                                                        <th>Level 3</th>
                                                        <th>Level 4</th>
                                                        <th>SKU</th>
                                                        <th>Product Code</th>
                                                        <th>MRP</th>
                                                        <th>MOP</th>
                                                        <th>BrandSKU</th>
                                                        <th>Mapped?</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {brand_data}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer">
                                <div className="stats"><i></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}
export default MerchantViewer;